import type {
  DesignLicenseStatusTypes,
  HqLicensingStatusTypes,
  PartialLicensingStatusTypes,
} from './Proof';
import type { DesignLicenseTagConfigType } from '@/common/interfaces/design.interface';

export type DesignLicenseTagRef = Record<HqLicensingStatusTypes, DesignLicenseTagConfigType>;

export const designLicenseStatusToPriorityMap: Record<DesignLicenseStatusTypes, number> = {
  needs_changes: 1,
  will_require_approval: 2,
  approval_required: 3,
  marks_in_review: 4,
  design_duplicate: 5,
  marks_pre_approved: 6,
  marks_approved: 7,
  no_marks: 8,
};

export const designLicenseV4HqMap: Record<PartialLicensingStatusTypes, HqLicensingStatusTypes> = {
  needs_changes: 'needs_changes',
  will_require_approval: 'licensing_review',
  approval_required: 'licensing_review',
  marks_in_review: 'licensing_review',
  marks_pre_approved: 'pre_approved',
  marks_approved: 'approved',
};

export const designLicenseComments: Record<HqLicensingStatusTypes, string> = {
  needs_changes: 'Oh no! Nationals rejected your design. They wrote:',
  will_require_approval:
    'Your design includes Greek trademarks that will require approval from Nationals. We will upload the final version for the review, which usually takes 1 - 3 business days.',
  licensing_review:
    "We're reviewing your design to make sure it turns out great. If anything needs to be changed, we'll let you know. Meanwhile, you can go ahead and order so you get it in time.",
  pre_approved:
    'We are pre- approving your design because we are 80% confident Nationals will approve it. We will still have to submit it for their final review, but you can go ahead and place order.',
  approved: 'Congrats! Nationals approved your design. You can now add it to your cart.',
};

export const needsChangesWorkWithYouMsg =
  'Don’t worry! We’ll work with you to revise the art and get it approved.';

export const needchangesGreekCollgMsg =
  'Oh no! Both Nationals and your School rejected your design. They wrote the explanation below. Our artists can change the design for you if you click “Request Changes” below or you can edit it yourself by clicking “Edit in Design Tool”.';

export const needChangesTooltipMsg =
  'Oh no! Nationals rejected your design. Click on the design to read their comments and make changes.';

export const designLicensePriorityToStatusMap: Record<number, DesignLicenseStatusTypes> = {
  1: 'needs_changes',
  2: 'will_require_approval',
  3: 'approval_required',
  4: 'marks_in_review',
  5: 'design_duplicate',
  6: 'marks_pre_approved',
  7: 'marks_approved',
  8: 'no_marks',
};

export const designLicenseTagConfig: DesignLicenseTagRef = {
  needs_changes: {
    label: 'Needs Changes',
    theme: 'danger',
    class: 'needs-changes',
    image: '/src/assets/svg/needs_changes.svg',
    key: 'needs_changes',
  },
  will_require_approval: {
    class: 'will-require-approval',
    theme: 'gray',
    image: '/src/assets/svg/will_require_approval.svg',
    label: 'Will Require Approval',
    key: 'will_require_approval',
  },
  licensing_review: {
    class: 'marks-in-review',
    theme: 'alt-warning',
    image: '/src/assets/svg/marks_in_review.svg',
    label: 'Licensing Review',
    key: 'marks_in_review',
  },
  pre_approved: {
    class: 'marks-pre-approved',
    theme: 'primary',
    image: '/src/assets/svg/marks_pre_approved.svg',
    label: 'Pre-Approved',
    key: 'marks_pre_approved',
  },
  approved: {
    class: 'marks-approved',
    theme: 'light-success',
    image: '/src/assets/svg/marks_approved.svg',
    label: 'Approved',
    key: 'marks_approved',
  },
};

export const NEEDS_CHANGES_REJECTION_MESSAGES = {
  collegiate:
    'Oh no! Your school rejected your design. You can only order this item after final approval. Don’t worry! We’ll work with you to revise the art and get it approved.',
  greek:
    'Oh no! Nationals has rejected your design. You can only order this item after final approval. Don’t worry! We’ll work with you to revise the art and get it approved.',
  both: 'Oh no! Nationals & your School rejected your design. Don’t worry! We’ll work with you to revise the art and get it approved.',
  block:
    'You’ve designed merch so unique that we need to take help from logistics to price this item.Don’t worry your account manager is on it!',
  collegiateCheckout:
    'Oh no! Your school rejected your design. You need to loop in your account manager as you can only order this item after final approval.Don’t worry! We’ll work with you to revise the art and get it approved.',
  greekCheckout:
    'Oh no! Nationals has rejected your design. You need to loop in your account manager as you can only order this item after final approval. Don’t worry! We’ll work with you to revise the art and get it approved.',
  bothCheckout:
    'Oh no! Nationals & your School rejected your design. You need to loop in your account manager as you can only order this item after final approval. Don’t worry! We’ll work with you to revise the art and get it approved.',
};
